var map = {
	"./1.png": 1554,
	"./10.png": 7352,
	"./11.png": 5119,
	"./12.png": 6031,
	"./13.png": 3458,
	"./14.png": 6894,
	"./15.png": 6482,
	"./16.png": 9483,
	"./2.png": 2979,
	"./3.png": 6900,
	"./4.png": 4642,
	"./5.png": 6235,
	"./6.png": 2999,
	"./7.png": 8075,
	"./8.png": 7045,
	"./9.png": 2978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7222;